<template>
  <v-card
    class="text-center rounded-xl"
    elevation="0"
    height="135px"
    width="100%"
    color="teal"
    dark
  >
    <p class="text-h5 mt-1 mb-0">Рейтинг</p>
    <div class="text-h5 pa-0 ma-0 mt-2" v-if="!ifRatingloading">
      {{ record_book.rating_result }}
      <p class="text-subtitle-2 pa-0 ma-0">Общий, за два прошлых семестра</p>
      <v-dialog
        content-class="rounded-xl"
        v-model="dialog"
        scrollable
        max-width="700px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            text
            icon
            v-on="on"
          >
            <v-icon class="pa-0 ma-0"> fa-info-circle</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <div>Расшифровка РАУ</div>
            <v-spacer></v-spacer>
            <v-btn
              icon
              text
              @click="dialog = false"
            >
              <v-icon size="20">fa-times</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle class="pt-2">{{namesTwoSemesters}}</v-card-subtitle>
          <v-card-text class="ma-0 pa-0">
            <v-simple-table class="fixed-header" v-if="!(namesTwoSemesters === 'Оценки отсутсвуют')">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left font-weight-black text-subtitle-1">
                    Дисциплина
                  </th>
                  <th class="text-left font-weight-black text-subtitle-1">
                    Оценка
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="item in semestrsInfo"
                  :key="item.id"
                >
                  <td>{{ item.subject }}</td>
                  <td>{{ item.mark === null ? 'Оценка отсутствует' : item.mark}}</td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </div>
    <v-progress-circular class="mt-4" color="white" width="4" size="50" indeterminate v-else></v-progress-circular>
  </v-card>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "StudRating",
        data: () => ({
            dialog: false,
        }),
        mounted() {
            this.GetRecordBook();
        },
        methods: {
            ...mapMutations({
                setRecordBook: 'mainHostel/setRecordBook',
            }),
            ...mapActions({
                GetRecordBook: 'mainHostel/GetRecordBook',
            }),
        },
        computed: {
            ...mapState({
                ifRatingloading: state => state.mainHostel.ifRatingloading,
                record_book: state => state.mainHostel.record_book
            }),
            ...mapGetters({
                semestrsInfo: 'mainHostel/semestrsInfo',
            }),

            namesTwoSemesters() {
                if (this.record_book.records) {
                    let last_semesters = this.record_book?.last_semesters
                    let first_semester = last_semesters[0]
                    let second_semester = last_semesters[1]

                    if (second_semester){
                        first_semester = first_semester? first_semester + ', ' : ''

                        return first_semester + second_semester
                    }
                }
                return 'Оценки отсутсвуют'
            }
        },
    }
</script>

<style scoped>

</style>